'use strict';

var AppState = require('app_state');
var Consts = require('consts');
var I18N = require('utils/i18n');
var FilterSelectWizardView = require('components/devices/views/common/filter_select_wizard_view');
var Misc = require('utils/misc');
var OOP = require('utils/oop');

function getSeriesRow(e) {
    if (e.currentTarget) return getSeriesRow(e.currentTarget);

    var $row = $(e).closest('div.row');
    return {
        row: $row,
        idx: $row.attr('data-idx'),
        find: function (what) {
            return this.row.find(what);
        },
    };
}

function getSeriesIdx(e) {
    var s = getSeriesRow(e);
    return s.idx;
}

module.exports = OOP.extend(
    FilterSelectWizardView,
    {
        template: require('components/devices/templates/virtual/virtual_device_dialog'),
        events: OOP.inheritedObj('events', {
            'click .js-delete-series': function (e) {
                this.data.series.splice(getSeriesIdx(e), 1);
                this.render();
            },
            'click .js-add-series': function (e) {
                var self = this;
                var cols = Misc.selectWhere(AppState.uniqueColumns(), function (item) {
                    return self.isValidSeries(item);
                });
                var series = {
                    aggregation: Consts.Aggregation[0].id,
                    value: cols[0].id,
                };
                this.setSeriesDefaultName(series);
                this.data.series.push(series);
                this.render();
            },
            'change select.js-edit-series': function (e) {
                this.saveSeriesRow(e, true);
                this.render();
            },

            'keyup input.js-edit-series': function (e) {
                this.saveSeriesRow(e);
                this.updateWizardButtons();
            },
            'change select.js-vd': function (e) {
                this.saveDeviceInfo();
                this.updateWizardButtons();
            },
            'keyup input.js-vd': function (e) {
                this.saveDeviceInfo();
                this.updateWizardButtons();
            },
        }),

        getWizardButtons: function () {
            return {
                prev: { title: I18N.TR('Zurück') },
                next: { title: I18N.TR('Weiter') },
                cancel: { title: I18N.TR('Abbrechen') },
                done: { title: I18N.TR('Gerät anlegen') },
            };
        },

        setError: function (err) {
            this.base.setError(err);
            this.changePage(this.selected, true);
        },

        getTabNames: function () {
            return {
                Filter: I18N.TR('Filter'),
                Devices: I18N.TR('Geräte'),
                Series: I18N.TR('Datenpunkte'),
                VirtualDevice: I18N.TR('Gerät'),
            };
        },

        saveDeviceInfo: function () {
            this.data.name = this.$el.find('#vd-name-input').val();
            this.data.interval = parseInt(this.$el.find('select.js-vd-interval').val());
        },

        setSeriesDefaultName: function (series) {
            var cols = AppState.uniqueColumns();
            series.name =
                Misc.selectWhereFirst(
                    cols,
                    function (item) {
                        return item.id == series.value;
                    },
                    'name'
                ) +
                (Misc.isVirtual(series.value)
                    ? ''
                    : ' - ' +
                      Misc.selectWhereFirst(
                          Consts.Aggregation,
                          function (item) {
                              return item.id == series.aggregation;
                          },
                          'name'
                      ));
        },

        saveSeriesRow: function (e, setDefaultName) {
            var s = getSeriesRow(e);
            var series = this.data.series[s.idx];
            series.name = s.find('.js-name').val();
            series.aggregation = s.find('select.js-aggregation').val();
            series.value = s.find('select.js-value').val();
            if (setDefaultName) {
                this.setSeriesDefaultName(series);
            }
        },

        onRender: function () {
            Misc.initSelectPicker();
        },

        canWizardChange: function (is, was) {
            var r = this.base.canWizardChange(is, was);
            if (r && this.currentWizardContext && this.currentWizardContext.permCtx) {
                if ((this.currentWizardContext.permCtx.selectedName == 'Series') & (is > was)) {
                    return (
                        this.data.series.length > 0 &&
                        Misc.countWhere(this.data.series, function (item) {
                            return item.isDuplicate;
                        }) == 0
                    );
                }
            }
            return r;
        },

        canWizardFinish: function () {
            var prev = this.base.canWizardFinish();
            if (!prev) return prev;

            this.finalizeSeries();
            return (
                this.data.series &&
                this.data.series.length > 0 &&
                Misc.countWhere(this.data.series, function (item) {
                    return item.isDuplicate;
                }) == 0 &&
                this.data.name.length > 0
            );
        },

        initialize: function (options) {
            this.base.initialize(options);
            this.data = {
                series: undefined,
                name: '',
                interval: 1,
            };
            this.errors = {};
            this.controller = options.controller;
            this.filterIntf = this.installFilter(
                {
                    filter: options.filter,
                    selection: options.selection,
                },
                {
                    onValidateFilter: function (filter, errors) {
                        if (!filter.category || !filter.category.length)
                            errors.type = I18N.TR('Bitte wählen Sie mindestens eine Gerätekategorie aus.');

                        var catCount = {};
                        _.each(filter.category, function (cat) {
                            var idx = cat == Consts.CategoryData.Virtual.category;
                            catCount[idx] = (catCount[idx] || 0) + 1;
                        });

                        if (catCount[true] && catCount[false])
                            errors.type = I18N.TR('Virtuelle und physische Geräte können nicht kombiniert werden.');
                    },
                }
            );

            this.data.series = options.series ? this.getInitSeries(options.series) : [];
        },

        getInitSeries: function (series) {
            var interns = {};
            _.each(AppState.uniqueColumns(), function (item) {
                if (item.isVirtualIntern) interns[item.id] = true;
            });

            return Misc.selectWhere(Misc.cloneAsJSON(series), function (item) {
                return !interns[item.value];
            });
        },

        wizardDone: function () {
            this.error = undefined;
            var virtualDeviceData = {
                filter: this.filterIntf.filter,
                series: this.data.series,
                name: this.data.name,
                interval: 10,
                category: Consts.Category.Virtual,
                state_data_names: {
                    1: I18N.TR('Anzahl der Geräte'),
                    2: I18N.TR('Anzahl der gültigen Geräte'),
                    3: I18N.TR('Anzahl der fehlerhaften Geräte'),
                    4: I18N.TR('Anzahl der Offline-Geräte'),
                },
            };
            if (this.options.cb) {
                this.options.cb(virtualDeviceData);
            }
        },

        onGotoPage: function (page, previous) {
            switch (this.wizardPermCtx.selectedName) {
                case 'Series':
                    break;
                default:
                    this.base.onGotoPage(page, previous);
            }
        },

        finalizeSeries: function () {
            var seriesMap = {};
            _.each(this.data.series, function (item, idx) {
                var key = item.value + item.aggregation;
                item.idx = idx;
                item.isDuplicate = !!seriesMap[key];
                item.isVirtual = Misc.isVirtual(item.value);
                if (item.isVirtual) item.aggregation = Misc.getVirtualAggregation(item.value);
                seriesMap[key] = true;
            });
        },

        isValidSeries: function (item) {
            var isVirtual = (this.filterIntf || {}).isVirtual;
            return !item.isVirtualIntern && !!item.isVirtual == !!isVirtual;
        },

        serializeData: function () {
            // set idx at all series and check duplicities
            this.finalizeSeries();
            var self = this;

            var data = this.base.serializeData();
            data.series = this.data.series;
            data.availableValues = Misc.selectWhere(AppState.uniqueColumns(), function (item) {
                return self.isValidSeries(item);
            });

            data.aggregations = Consts.Aggregation;
            data.name = this.data.name;
            data.interval = this.data.interval;
            data.errors = this.errors;
            return data;
        },
    },
    'VirtualDeviceDialogView'
);
